var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMClientes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.438,
    height: 20.438,
    viewBox: "0 0 20.438 20.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "m-clientes",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path981",
    d: "M0-305.447a9.219,9.219,0,0,0,9.219,9.219,9.219,9.219,0,0,0,9.219-9.219,9.219,9.219,0,0,0-9.219-9.219A9.219,9.219,0,0,0,0-305.447Z",
    transform: "translate(0 314.666)",
    fill: "rgba(0,0,0,0)",
    stroke: "#0f1824",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15930",
    "data-name": "Grupo 15930",
    transform: "translate(-48.281 -263.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g983",
    transform: "translate(55.25 268.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path985",
    d: "M-197.875-98.938a2.4,2.4,0,0,1-2.4,2.4,2.4,2.4,0,0,1-2.4-2.4,2.4,2.4,0,0,1,2.4-2.4A2.4,2.4,0,0,1-197.875-98.938Z",
    transform: "translate(202.666 101.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#a6abaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g987",
    transform: "translate(54.24 275.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path989",
    d: "M-289.1-61.185a4.031,4.031,0,0,0-3.126-1.481h-.748a4.031,4.031,0,0,0-3.126,1.481",
    transform: "translate(296.103 62.667)",
    fill: "rgba(0,0,0,0)",
    stroke: "#a6abaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMClientes);
export default __webpack_public_path__ + "static/media/m-clientes.3a3ac38d6caac671d17213ff8ecdd3c1.svg";
export { ForwardRef as ReactComponent };